import axios from 'axios';
import { config } from '../configuration';
import { renderRetryPage } from '../index';

const defaultOptions = {
  withCredentials: `${config.credentialsMode}`,
  // mode: 'cors',
  // redirect: 'manual',
};

// TODO: 1. Nicer way to express below. 2. Delegate exact client version, too. 3. New value of config not read.
function getCustomeHeaders() {
  return config.isImprivata
    ? {
        'X-Pake-Client-Name': 'Tilaaja',
        'X-Pake-Client-Os': 'Android',
        'X-Pake-Client-Version': '3',
        'X-Pake-User-AdName': config.adUsername,
        Authorization: config.basicAuthHeader,
      }
    : {
        'X-Pake-Client-Name': 'Tilaaja',
        'X-Pake-Client-Os': 'Browser',
      };
}

/** *******
 * HELPERS
 * ******* */

const handleResponse = response => {
  if (config.isImprivata && response.status === 401) {
    renderRetryPage('Session expired or nonexisting.');
  }

  if (response.status === 200) {
    if (
      !config.isImprivata &&
      response.headers['content-type'] !== 'application/json;charset=UTF-8'
    ) {
      // console.error(response);
      return window.location.reload();
    }

    return response.data;
  }

  throw new Error('API Error');
};

const handleError = err => {
  console.log(err);
  throw new Error(`Error in fetch: ${err.message}`);
};

/** ***********
 * API METHODS
 * ************ */

export const get = (endpoint, options = {}) => {
  const url = `${config.apiUrl}${endpoint}`;

  return axios({
    ...defaultOptions,
    headers: getCustomeHeaders(),
    method: 'get',
    url,
    ...options,
  })
    .then(handleResponse)
    .catch(handleError);
};

export const post = (endpoint, data = {}, options = {}) => {
  const url = `${config.apiUrl}${endpoint}`;
  const opts = {
    ...defaultOptions,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...getCustomeHeaders(),
    },
    ...options,
    data: JSON.stringify(data),
  };

  return axios({
    method: 'post',
    url,
    ...opts,
  })
    .then(handleResponse)
    .catch(handleError);
};

export const put = (endpoint, data = {}, options = {}) => {
  const url = `${config.apiUrl}${endpoint}`;
  const opts = {
    ...defaultOptions,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...getCustomeHeaders(),
    },
    ...options,
    data: JSON.stringify(data),
  };

  return axios({
    method: 'put',
    url,
    ...opts,
  })
    .then(handleResponse)
    .catch(handleError);
};

export const del = (endpoint, data = {}, options = {}) => {
  const url = `${config.apiUrl}${endpoint}`;
  const opts = {
    ...defaultOptions,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...getCustomeHeaders(),
    },
    ...options,
    data: JSON.stringify(data),
  };

  return axios({
    method: 'delete',
    url,
    ...opts,
  })
    .then(handleResponse)
    .catch(handleError);
};
